import { useCallback, useEffect } from "react";
import { ModalName } from "@/shared/modals";
import { useModalContext } from "@/shared/contexts/modal.context";

export const useModal = (
  modalFileName: ModalName,
  defaultProps: { [key: string]: any } = {}
) => {
  const { openModal, closeModal, updateModal } = useModalContext();

  const handleOpenModal = useCallback(
    (
      metaProps: { [key: string]: any } = {},
      modalStackProps?: { [key: string]: any }
    ) => {
      const meta = { ...defaultProps, ...metaProps };
      openModal(modalFileName, meta, modalStackProps);
    },
    [defaultProps, modalFileName, openModal]
  );

  const handleCloseModal = useCallback(
    (modalStackProps?: { [key: string]: any }) => {
      closeModal(modalFileName, modalStackProps);
    },
    [modalFileName, closeModal]
  );

  const handleUpdateModal = useCallback(
    (
      metaProps: { [key: string]: any } = {},
      modalStackProps?: { [key: string]: any }
    ) => {
      const meta = { ...defaultProps, ...metaProps };
      updateModal(modalFileName, meta, modalStackProps);
    },
    [defaultProps, modalFileName, updateModal]
  );

  return [handleOpenModal, handleCloseModal, handleUpdateModal];
};
